export const cachecatalogs = {
  clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
  completedTime: '',
  requestId: '667267c05fee77554c70ca1e',
  startedTime: '2024-06-19T05:08:17',
  status: 'IN_PROGRESS',
};
